export const coursePlanDaysElId = 'course-plan-days';
